/* Steelmonks Belohnungs-Pfad: Kopfleiste, Panel im Warenkorb mit Pixel-Mönch, Marker-Produkte, Ereignisse für GA4 */
(function () {
  'use strict';
  const cfgEl = document.getElementById('smr-config');
  if (!cfgEl || window.SMR) return;
  let C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  const rate = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
  const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const JSONH = { 'Content-Type': 'application/json', Accept: 'application/json' };

  // Stufen: Beträge und Marker kommen aus der Konfiguration (Schwellen später testbar), Texte stehen hier
  const LBL = ['Gratisversand', '5 € Rabatt', '10 € Rabatt'];
  const T = [
    { id: 'free_shipping', short: 'bis zum Gratisversand', m: 'bis Gratisversand', lead: 'dann ist Dein Versand kostenlos', done: 'Gratisversand gesichert', toast: 'Gratisversand freigeschaltet!', hint: 'Dein Versand ist jetzt kostenlos.', img: C.img.jakob, icon: 'truck' },
    { id: 'discount_5', short: 'für 5 € Rabatt', m: 'für 5 € Rabatt', lead: 'dann gibt es 5 € Rabatt', done: '5 € Rabatt gesichert', toast: '5 € Rabatt freigeschaltet!', hint: 'Wird automatisch abgezogen.', img: C.img.tag5, icon: 'tag', ersetzt: 2 },
    // Ab 199 € ersetzt der 10-€-Rabatt den 5-€-Rabatt (Shopify zieht nur den höheren ab): „statt 5 €“, und der 5-€-Marker geht (ersetzt)
    { id: 'discount_10_199', short: 'für 10 € Rabatt', m: 'für 10 € Rabatt', lead: 'dann gibt es 10 € statt 5 € Rabatt', done: '10 € Rabatt gesichert', toast: '10 € Rabatt freigeschaltet!', hint: 'Statt 5 € ziehen wir jetzt 10 € ab.', img: C.img.tag, icon: 'tag' }
  ].map((t, i) => Object.assign(t, C.tiers[i], { cents: Math.round(C.tiers[i].at * 100 * rate) }, { label: LBL[i], tile: [C.img.jakob, C.img.tag5, C.img.tag][i], title: ['Versand', '5 € Rabatt', '10 € Rabatt'][i], on: ['kostenlos', 'freigeschaltet', 'freigeschaltet'][i] }));
  const MAX = T[T.length - 1].cents;
  const MARK = new Set(T.map((t) => t.marker).concat(C.alt || []));
  const SIGN = /schild(er)?$|^(monogramm|wappen)$/i, NOSIGN = /klingel|stra(ß|ss)en/i;
  // Geschenktüte wie in sm-cart-extras.liquid: 1 klein, 2 groß, 0 keine (Straßenschilder, Hausnummern, Eckdeko, Wandregale, über 55 cm)
  const BAG = C.bag || {}, BAG_NO = /stra(ß|ss)en|hausnummer|eckdeko|wandregal|pplr_hidden/i, BAG_SMALL = /anhänger|anstecker|kartenhalter|feuerzeug|halskette|dog[ -]tag|geldscheinklammer|patch/i, BAG_SIGN = /schild|wappen|monogramm|-set/i;
  const isBag = (i) => i.variant_id === BAG.k || i.variant_id === BAG.g;
  const cmOf = (s) => parseFloat(String(s).split('cm')[0].split('x')[0].replace(',', '.').trim()) || 0;
  function bagNeed(items) {
    return items.reduce((n, i) => {
      const t = i.product_type || '';
      if (isBag(i) || BAG_NO.test(t)) return n;
      let cm = 0;
      (i.variant_title || '').split(' / ').forEach((p) => { if (p.includes('cm')) cm = cmOf(p); });
      const g = i.properties && i.properties['Größe'];
      if (g && String(g).includes('cm')) cm = cmOf(g);
      if (cm > 55) return n;
      const k = cm > 22.5 ? 2 : cm > 0 ? 1 : BAG_SMALL.test(t) ? 1 : BAG_SIGN.test(t) ? 2 : 0;
      return Math.max(n, k);
    }, 0);
  }

  const store = (s) => ({ get(k) { try { return s.getItem(k); } catch (e) { return null; } }, set(k, v) { try { s.setItem(k, v); } catch (e) {} } });
  const SS = store(window.sessionStorage);
  const push = (event, data) => { try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event }, data)); } catch (e) {} };
  const money = (c) => (c / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  const amt = (c) => (c % 100 ? money(c) : (c / 100).toLocaleString('de-DE', { maximumFractionDigits: 0 }) + ' €');
  const esc = (s) => String(s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));

  // Pixel-Symbole als SVG (eine Zeile je Pixelreihe)
  const PX = {
    truck: ['#######.....', '#######.###.', '#######.#..#', '#######.#..#', '############', '############', '.##.....##..', '.##.....##..'],
    tag: ['..##########', '.###########', '###..#######', '###..#######', '.###########', '..##########'],
    chest: ['.#########.', '###########', '###########', '...........', '#####.#####', '####...####', '#####.#####', '###########', '###########'],
    check: ['.......##', '......##.', '##...##..', '.##.##...', '..###....', '...#.....'],
    lock: ['.###.', '#...#', '#...#', '#####', '##.##', '##.##', '#####']
  };
  const svg = (k) => {
    const r = PX[k], w = r[0].length, h = r.length;
    let d = '';
    r.forEach((row, y) => { for (let x = 0; x < w;) { if (row[x] !== '#') { x++; continue; } const s = x; while (x < w && row[x] === '#') x++; d += 'M' + s + ' ' + y + 'h' + (x - s) + 'v1h-' + (x - s) + 'z'; } });
    return '<svg viewBox="0 0 ' + w + ' ' + h + '" width="' + w + '" height="' + h + '" shape-rendering="crispEdges" aria-hidden="true" focusable="false"><path d="' + d + '"/></svg>';
  };

  // Zustand aus /cart.js: Marker zählen nicht mit
  function derive(cart) {
    const items = cart.items.filter((i) => !MARK.has(i.variant_id));
    const used = new Set();
    (cart.cart_level_discount_applications || []).forEach((d) => used.add(String(d.title || '').toUpperCase()));
    items.forEach((i) => (i.line_level_discount_allocations || []).forEach((a) => used.add(String((a.discount_application || {}).title || '').toUpperCase())));
    // Ein gültiger Code ohne Abzug im Warenkorb ist ein Versandcode (Newsletter-Code, nur DE/AT)
    const shipCode = C.codeCountries.indexOf(C.country) > -1 && (cart.discount_codes || []).some((d) => d.applicable && !used.has(String(d.code).toUpperCase()));
    // Wie Shopify die Mindestbeträge prüft: nach Artikelrabatten und Rabattcodes, ohne die automatischen Rabatte selbst
    const codes = (cart.cart_level_discount_applications || []).filter((d) => d.type === 'discount_code').reduce((s, d) => s + (d.total_allocated_amount || 0), 0);
    return { total: Math.max(0, cart.items_subtotal_price - codes), count: items.reduce((s, i) => s + i.quantity, 0), items, shipCode, cart };
  }
  function view(st) {
    const reached = T.map((t) => st.count > 0 && st.total >= t.cents);
    const shipFree = reached[0] || (st.count > 0 && st.shipCode);
    const next = T.find((t, i) => !reached[i] && !(i === 0 && shipFree));
    return { reached, shipFree, next, total: st.total, empty: !st.count, gap: next ? next.cents - st.total : 0, p: Math.max(0, Math.min(1, st.total / MAX)), level: reached.filter(Boolean).length };
  }

  let S = null;
  // Pixel-Mönch je Stufe: leer (Karton), sucht (Lupe), ab 99 € Skizze, ab 149 € am Laser, ab 199 € Kaffeepause
  const monk = (v) => (v.empty ? 'karton' : ['lupe', 'skizze', 'laser', 'kaffee'][v.level]);

  // Schiene mit Stationen und Mönch; mode: bar (Kopfleiste), mini und big (Warenkorb: Stationen oben, Mönch läuft darunter auf eigenem Pfad)
  function railHTML(v, mode, p) {
    const big = mode === 'big';
    const pos = (x) => ' style="--p:' + x.toFixed(4) + '"';
    let h = '<span class="smr-track"><span class="smr-fill"' + pos(p) + '></span></span>';
    T.forEach((t, i) => {
      const f = t.cents / MAX, done = i === 0 ? v.shipFree : v.reached[i], cls = done ? ' is-done' : '';
      if (mode === 'p') {
        h += '<span class="smr-node smr-node--' + (i + 1) + cls + '"' + pos(f) + '><img src="' + C.img.icons[i] + '" alt="" width="17" height="17"></span>' +
          '<small class="smr-lbl' + cls + '"' + pos(f) + '>' + (i === 0 && done && !v.reached[0] ? 'Code' : amt(t.cents)) + '</small>';
      } else if (big) {
        h += '<span class="smr-node smr-node--big' + cls + '"' + pos(f) + '><img src="' + t.img + '" alt="" decoding="async"><i class="smr-badge">' + svg(done ? 'check' : 'lock') + '</i></span>' +
          '<span class="smr-dot' + cls + '"' + pos(f) + '></span>' +
          '<small class="smr-lbl' + cls + '"' + pos(f) + '>' + (i === 0 && done && !v.reached[0] ? 'Code' : amt(t.cents)) + '</small>';
      } else {
        h += '<span class="smr-node smr-node--' + (i + 1) + cls + '"' + pos(f) + '><img src="' + C.img.icons[i] + '" alt="" width="16" height="16"></span>' + (mode === 'mini' ? '<span class="smr-dot' + cls + '"' + pos(f) + '></span>' : '');
      }
    });
    return h + '<img class="smr-monk smr-monk--' + monk(v) + '" src="' + C.img.monks[monk(v)] + '" alt="" decoding="async"' + pos(p) + '>';
  }
  // Neu zeichnen, dann läuft der Mönch von der alten zur neuen Stelle
  function monkFrac(v, box) {
    const W = Math.max(120, box.clientWidth - 32), g = 26 / W, f = T.map((t) => t.cents / MAX), t = v.empty ? 0 : v.total;
    const seg = (a, b, x0, x1) => x0 + (x1 - x0) * Math.max(0, Math.min(1, (t - a) / (b - a)));
    if (t <= 0) return 0;
    if (t < T[0].cents) return seg(0, T[0].cents, 0, f[0] - g);
    if (t < T[1].cents) return seg(T[0].cents, T[1].cents, f[0] + g, f[1] - g);
    if (t < T[2].cents) return seg(T[1].cents, T[2].cents, f[1] + g, f[2] - g);
    return f[2] - g;
  }
  function paintRail(box, v, mode) {
    const key = mode === 'bar' ? 'smrPh' : 'smrPb', old = box.querySelector('.smr-monk');
    let from = old ? parseFloat(old.style.getPropertyValue('--p')) : parseFloat(SS.get(key));
    if (isNaN(from)) from = mode === 'bar' ? v.p : 0;
    box.innerHTML = railHTML(v, mode, from);
    const to = mode === 'p' ? monkFrac(v, box) : v.p;
    v = Object.assign({}, v, { p: to });
    SS.set(key, String(v.p));
    if (Math.abs(from - v.p) < 0.002) return;
    const monk = box.querySelector('.smr-monk'), fill = box.querySelector('.smr-fill');
    void box.offsetWidth;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      monk.style.setProperty('--p', v.p.toFixed(4)); fill.style.setProperty('--p', (mode === 'p' ? Math.max(0, Math.min(1, v.total / MAX)) : v.p).toFixed(4));
      if (!RM) { monk.classList.add('is-walking'); setTimeout(() => monk.classList.remove('is-walking'), 1000); }
    }));
  }

  // Handy-Leiste: Zeitstrahl über die volle Breite wie am Desktop; der Mönch läuft bei jedem Seitenaufruf vom linken Rand los,
  // an den Kreisen ist er genau bei 99, 149 und 199 €. Antippen klappt die Details auf.
  const mbar = document.querySelector('[data-smr-bar]');
  let mX = null;
  function infoHTML(st, v) {
    let lead;
    if (!st.count) lead = 'Mit Deinem Warenkorb sammelst Du Belohnungen:';
    else if (v.next) lead = (v.shipFree && !v.reached[0] ? 'Versand mit Deinem Code kostenlos. ' : '') + 'Noch <b>' + money(v.gap) + '</b> ' + v.next.short + '.';
    else lead = '<b>Alles freigeschaltet:</b> Gratisversand und 10 € Rabatt.';
    const rows = T.map((t, i) => {
      const done = i === 0 ? v.shipFree : v.reached[i];
      const st2 = done ? '\u2713 ' + (i === 1 && v.reached[2] ? 'jetzt 10 €' : 'gesichert') : st.count ? 'noch ' + money(t.cents - st.total) : '';
      return '<li' + (done ? ' class="is-done"' : '') + '><span class="smr-minfo__ic"><img src="' + C.img.icons[i] + '" alt="" width="15" height="15"></span><span><b>' + LBL[i] + '</b>ab ' + amt(t.cents) + '</span><span class="smr-minfo__st">' + st2 + '</span></li>';
    }).join('');
    return '<p class="smr-minfo__lead">' + lead + '</p><ul class="smr-minfo__list">' + rows + '</ul><a class="smr-minfo__go" href="' + ROOT + 'cart" data-smr-mgo>' + (st.count ? 'Zum Warenkorb' : 'Warenkorb ansehen') + '</a>';
  }
  function paintBar(st, instant) {
    if (!mbar) return;
    const v = view(st), info = mbar.querySelector('[data-smr-minfo]'), btn = mbar.querySelector('[data-smr-mtoggle]');
    mbar.classList.toggle('is-empty', !st.count);
    info.innerHTML = infoHTML(st, v);
    const tmp = document.createElement('div'); tmp.innerHTML = info.querySelector('.smr-minfo__lead').innerHTML;
    btn.setAttribute('aria-label', tmp.textContent + ' Details anzeigen');
    mbar.querySelectorAll('[data-smr-mpt]').forEach((p) => { const i = +p.dataset.smrMpt; p.classList.toggle('is-done', !!(i === 0 ? v.shipFree : v.reached[i])); });
    const line = mbar.querySelector('.smr-mline');
    if (!line.offsetParent) return; // am Desktop ausgeblendet
    const L = line.getBoundingClientRect().left, W = line.clientWidth;
    const c = [...mbar.querySelectorAll('[data-smr-mpt]')].map((p) => { const r = p.getBoundingClientRect(); return r.left + r.width / 2 - L; });
    const total = st.count ? st.total : 0, d = 36, seg = (a, b, x0, x1) => x0 + (x1 - x0) * Math.max(0, Math.min(1, (total - a) / (b - a)));
    const x = total <= 0 ? 24 : total < T[0].cents ? seg(0, T[0].cents, 24, c[0] - d) : total < T[1].cents ? seg(T[0].cents, T[1].cents, c[0] + d, c[1] - d)
      : total < T[2].cents ? seg(T[1].cents, T[2].cents, c[1] + d, c[2] - d) : seg(T[2].cents, Math.round(T[2].cents * 1.5), c[2] + d, W - 58);
    const m = mbar.querySelector('[data-smr-mmonk]'), fill = mbar.querySelector('[data-smr-mfill]'), k = monk(v);
    if (m.dataset.k !== k) { m.src = C.img.monks[k]; m.dataset.k = k; }
    const from = mX === null ? 0 : mX, dist = Math.abs(x - from);
    const dur = RM || instant ? 0 : Math.min(6, Math.max(0.6, 6 * dist / W));
    [m, fill].forEach((el) => { el.style.transitionDuration = dur + 's'; });
    if (mX === null) { m.style.left = '0px'; fill.style.width = '0px'; void m.offsetWidth; }
    requestAnimationFrame(() => { m.style.left = x + 'px'; fill.style.width = x + 'px'; });
    if (dur && dist > 2) { m.classList.add('is-walking'); clearTimeout(m._w); m._w = setTimeout(() => m.classList.remove('is-walking'), dur * 1000); }
    mX = x;
  }
  if (mbar) {
    const btn = mbar.querySelector('[data-smr-mtoggle]'), info = mbar.querySelector('[data-smr-minfo]');
    const setOpen = (on) => { info.hidden = !on; btn.setAttribute('aria-expanded', on ? 'true' : 'false'); if (on) once('mbar_open', () => push('sm_reward_bar_open', { sm_cart_value: S ? S.total / 100 : 0 })); };
    btn.addEventListener('click', () => setOpen(info.hidden));
    document.addEventListener('click', (e) => { if (!info.hidden && !mbar.contains(e.target)) setOpen(false); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !info.hidden) { setOpen(false); btn.focus(); } });
    let rz = 0;
    addEventListener('resize', () => { clearTimeout(rz); rz = setTimeout(() => { if (S) { mX = null; paintBar(S, true); } }, 200); });
  }

  // Desktop-Zeitstrahl über die volle Breite: der Mönch läuft bei jedem Seitenaufruf vom linken Rand los wie bisher,
  // an den Kreisen ist er genau bei 99, 149 und 199 €, danach geht es bis 95 % der Breite weiter
  const strip = document.querySelector('[data-smr-strip]');
  let stripX = null, stripTotal = null;
  function stripGeom() {
    const line = strip.querySelector('.milestones__timeline'), L = line.getBoundingClientRect().left, W = line.clientWidth;
    return { W, cs: [...strip.querySelectorAll('[data-smr-pt]')].map((p) => { const r = p.getBoundingClientRect(); return r.left + r.width / 2 - L; }) };
  }
  function stripPos(total, g) {
    // Zwischen den Kreisen bleibt er stehen, nicht dahinter (Abstand d): ab 99 € rechts neben dem ersten Kreis usw.
    const d = 40, c = g.cs, seg = (a, b, x0, x1) => x0 + (x1 - x0) * Math.max(0, Math.min(1, (total - a) / (b - a)));
    if (total <= 0) return 22;
    if (total < T[0].cents) return seg(0, T[0].cents, 22, c[0] - d);
    if (total < T[1].cents) return seg(T[0].cents, T[1].cents, c[0] + d, c[1] - d);
    if (total < T[2].cents) return seg(T[1].cents, T[2].cents, c[1] + d, c[2] - d);
    return seg(T[2].cents, Math.round(T[2].cents * 1.5), c[2] + d, g.W * 0.95);
  }
  function paintStrip(st, instant) {
    if (!strip || !strip.offsetParent) return;
    const v = view(st), g = stripGeom(), x = stripPos(st.count ? st.total : 0, g);
    const m = strip.querySelector('[data-smr-monk]'), fill = strip.querySelector('[data-smr-fill]'), k = monk(v);
    if (m.dataset.k !== k) { m.src = C.img.monks[k]; m.dataset.k = k; }
    strip.querySelectorAll('[data-smr-pt]').forEach((p) => {
      const i = +p.dataset.smrPt, t = T[i], done = i === 0 ? v.shipFree : v.reached[i];
      const txt = done ? (i === 0 && !v.reached[0] ? 'Versand mit Deinem Code kostenlos' : i === 1 && v.reached[2] ? 'Statt 5 € jetzt 10 € Rabatt!' : t.done + '!')
        : st.count ? 'Noch ' + money(t.cents - st.total) + ' ' + t.short : LBL[i] + ' ab ' + amt(t.cents);
      p.classList.toggle('is-done', done);
      p.querySelector('[data-smr-tip]').textContent = txt;
      p.setAttribute('aria-label', txt);
    });
    const from = stripX === null ? 0 : stripX, dist = Math.abs(x - from);
    const dur = RM || instant ? 0 : Math.min(8, Math.max(0.6, 8 * dist / g.W));
    [m, fill].forEach((el) => { el.style.transitionDuration = dur + 's'; });
    if (stripX === null) { m.style.left = '0px'; fill.style.width = '0px'; void m.offsetWidth; }
    requestAnimationFrame(() => { m.style.left = x + 'px'; fill.style.width = x + 'px'; });
    if (dur && dist > 2) { m.classList.add('is-walking'); clearTimeout(m._w); m._w = setTimeout(() => m.classList.remove('is-walking'), dur * 1000); }
    stripX = x;
    // Text zur nächsten Stufe kurz zeigen: nach einer Warenkorb-Änderung und einmal je Sitzung nach dem Laufen
    const changed = stripTotal !== null && S && st.total !== stripTotal;
    if (S) stripTotal = st.total;
    if (v.next && st.count && (changed || (S && !SS.get('smrRemind')))) {
      SS.set('smrRemind', '1');
      const p = strip.querySelector('[data-smr-pt="' + T.indexOf(v.next) + '"]');
      clearTimeout(strip._r);
      strip._r = setTimeout(() => { p.classList.add('is-remind'); setTimeout(() => p.classList.remove('is-remind'), 4500); }, changed ? 400 : Math.max(1500, dur * 1000));
    }
  }
  if (strip) {
    let rz = 0;
    addEventListener('resize', () => { clearTimeout(rz); rz = setTimeout(() => { if (S) { stripX = null; paintStrip(S, true); } }, 200); });
  }

  // Passt dazu: kleine Artikel ohne Personalisierung, die die Lücke zur nächsten Stufe schließen
  function addons(st, v) {
    const pids = new Set(st.items.map((i) => i.product_id));
    const hasSign = st.items.some((i) => SIGN.test(i.product_type || '') && !NOSIGN.test(i.product_type || ''));
    const hasMount = st.items.some((i) => /befestigungsset/i.test(i.product_type || '') || Object.keys(i.properties || {}).some((k) => /befestig/i.test(k + ' ' + i.properties[k]) && !/nein|ohne/i.test(String(i.properties[k]))));
    const retter = st.items.some((i) => /feuerwehr|thw|retter|rettung/i.test((i.product_type || '') + ' ' + (i.product_title || '')));
    let list = C.addons.filter((a) => !pids.has(a.pid) && (a.rule === 'mount' ? hasSign && !hasMount : a.rule === 'retter' ? retter : true));
    const small = v.next && v.gap <= C.gapMax * 100 * rate;
    if (!small) list = list.filter((a) => a.rule === 'mount');
    const g = v.next ? v.gap : 0;
    list.sort((a, b) => (a.rule === 'mount') !== (b.rule === 'mount') ? (a.rule === 'mount' ? -1 : 1)
      : (a.price >= g) !== (b.price >= g) ? (a.price >= g ? -1 : 1) : a.price >= g ? a.price - b.price : b.price - a.price);
    return list;
  }
  function addonsHTML(st, v, max) {
    const list = addons(st, v).slice(0, max);
    if (!list.length) return '';
    const closes = v.next && list.every((a) => a.price >= v.gap);
    return '<div class="smr-gap"><p class="smr-gap__h">' + (closes ? 'Damit ' + v.next.lead.replace(/^dann /, '') + ':' : 'Passt dazu') + '</p>' +
      list.map((a) => '<div class="smr-add"><img src="' + esc(a.img) + '" alt="" width="44" height="44" loading="lazy"><span class="smr-add__t"><b>' + esc(a.title) + '</b><small>' + esc(a.sub) + '</small></span>' +
        '<button type="button" class="smr-add__b" data-smr-add="' + a.id + '" data-smr-key="' + esc(a.key) + '" aria-label="' + esc(a.title) + ' für ' + money(a.price) + ' hinzufügen">+ ' + money(a.price) + '</button></div>').join('') + '</div>';
  }

  // Panel im Warenkorb (Drawer und Seite /cart) wie im Prototyp; Liquid liefert frische Summe und Anzahl als Attribute
  let panelLevel = null;
  function tilesHTML(v) {
    return '<div class="smr-tiles">' + T.map((t, i) => {
      const on = i === 0 ? v.shipFree : v.reached[i], code = i === 0 && on && !v.reached[0];
      const pop = on && panelLevel !== null && i >= panelLevel && i < v.level;
      return '<div class="smr-tile' + (on ? ' is-on' : '') + (pop ? ' is-pop' : '') + '"><span class="smr-tile__img smr-tile__img--px"><img src="' + t.tile + '" alt="" loading="lazy"></span>' +
        '<i class="smr-tile__lock">' + svg(on ? 'check' : 'lock') + '</i><b>' + t.title + '</b><span>' + (on ? (code ? 'mit Deinem Code' : i === 1 && v.reached[2] ? 'jetzt 10 €' : t.on) : 'ab ' + amt(t.cents)) + '</span></div>';
    }).join('') + '</div>';
  }
  function upsellHTML(st, v) {
    const a = addons(st, v).filter((x) => x.key !== 'bag')[0];
    if (!a) return '';
    const closes = v.next && a.price >= v.gap;
    const px = a.rule === 'mount' ? C.img.luisLadder : C.img.duoPin;
    return '<div class="smc-up"><img class="px" src="' + px + '" alt="" loading="lazy"><img class="ph" src="' + esc(a.img) + '" alt="" loading="lazy">' +
      '<span><b>' + esc(a.title) + '</b><small>' + esc(a.pitch || a.sub) + '</small>' + (closes ? '<small class="go">Damit ' + v.next.lead.replace(/^dann /, '') + '.</small>' : '') + '</span>' +
      '<button type="button" class="smc-pill" data-smr-add="' + a.id + '" data-smr-key="' + esc(a.key) + '" aria-label="' + esc(a.title) + ' für ' + money(a.price) + ' hinzufügen">+ ' + money(a.price) + '</button></div>';
  }
  function paintPanel(p) {
    const dt = parseInt(p.dataset.total, 10), dc = parseInt(p.dataset.count, 10);
    let st = S ? Object.assign({}, S) : { total: 0, count: 0, items: [], shipCode: false };
    // Dawn hat schon neu gerendert, der Abgleich läuft noch: ohne Vorschläge zeichnen, sonst steht kurz ein gerade gekaufter Artikel drin
    const fresh = !!S && (isNaN(dt) || dt === S.total) && (isNaN(dc) || dc === S.count);
    if (!isNaN(dt)) st.total = dt;
    if (!isNaN(dc)) st.count = dc;
    const host = p.closest('cart-drawer') || p.closest('cart-items'), up = host ? host.querySelector('[data-smr-upsell]') : null;
    if (!st.count) { p.hidden = true; p.innerHTML = ''; if (up) { up.hidden = true; up.innerHTML = ''; } return; }
    const v = view(st);
    p.innerHTML = '<div class="smr-card smr-card--p">' +
      '<p class="smr-lead">' + (v.next ? 'Noch <b>' + money(v.gap) + '</b> bis <b>' + v.next.label + '</b>' : '<b>Alle Belohnungen freigeschaltet!</b>') + '</p>' +
      '<div class="smr-rail smr-rail--p" aria-hidden="true"></div>' + tilesHTML(v) +
      (!up && fresh ? upsellHTML(st, v) : '') + '</div>';
    panelLevel = v.level;
    p.hidden = false;
    paintRail(p.querySelector('.smr-rail'), v, 'p');
    if (up) { const h = fresh ? upsellHTML(st, v) : ''; if (h || fresh) { up.innerHTML = h; up.hidden = !h; } }
    const open = p.closest('cart-drawer') ? p.closest('cart-drawer').classList.contains('active') : true;
    if (open) (up || p).querySelectorAll('[data-smr-key]').forEach((b) => once('gv_' + b.dataset.smrKey, () => push('sm_gapfill_view', { sm_item: b.dataset.smrKey, sm_gap: v.gap / 100 })));
  }
  const once = (k, fn) => { if (SS.get('smrE_' + k)) return; SS.set('smrE_' + k, '1'); fn(); };

  // Versandhinweis im Warenkorb-Fuß kennt den Newsletter-Code nicht (Liquid sieht keine Versandcodes)
  function paintNotes() {
    if (!S || !S.shipCode || view(S).reached[0]) return;
    document.querySelectorAll('.cart-freeship-confirm--open').forEach((n) => { n.classList.remove('cart-freeship-confirm--open'); n.innerHTML = '&#10003; Versand mit Deinem Code kostenlos'; });
    document.querySelectorAll('[data-smc-ship]:not([data-free])').forEach((n) => { n.setAttribute('data-free', ''); n.innerHTML = '<span>Versand</span><span class="smc-ok">kostenlos mit Code</span>'; });
    // Gesamt ohne den Versand, den Liquid eingerechnet hat (sm-cart-summary); Zeptos span bleibt stehen wie in sm-warenkorb-gesamt.js
    document.querySelectorAll('[data-smc-ohne]').forEach((n) => {
      const t = n.getAttribute('data-smc-ohne'), z = n.querySelector('[pplr_set_price],[pplr_s_price]');
      n.removeAttribute('data-smc-ohne'); n.setAttribute('data-sm-gesamt', t);
      if (z) z.textContent = t; else n.textContent = t;
      const tax = n.closest('.smc-sum, cart-drawer, #main-cart-items'), p = tax && tax.querySelector('[data-smc-tax]');
      if (p) p.textContent = 'Inkl. MwSt.';
    });
  }
  function mountAll() {
    document.querySelectorAll('[data-smr-panel]').forEach((p) => { if (p.dataset.smrOn !== (S ? 's' : 'l')) { p.dataset.smrOn = S ? 's' : 'l'; paintPanel(p); } });
    paintNotes();
    document.querySelectorAll('[data-smc-xs]:not([data-on])').forEach((b) => { b.dataset.on = '1'; paintXS(b); });
  }
  // Die Personalisierungs-App (pplr) schreibt cart.item_count in die Zahl am Warenkorb-Symbol, also mit Markern; hier korrigieren
  let bubbleFixes = 0;
  function fixBubble() {
    if (!S || !S.count || S.count > 99) return;
    const sp = document.querySelector('#cart-icon-bubble .cart-count-bubble span[aria-hidden]');
    if (sp && sp.textContent.trim() !== String(S.count)) sp.textContent = String(S.count);
  }
  const bubbleEl = document.getElementById('cart-icon-bubble');
  if (bubbleEl) new MutationObserver(() => { if (bubbleFixes++ < 20) fixBubble(); }).observe(bubbleEl, { childList: true, subtree: true, characterData: true });
  function renderAll() {
    bubbleFixes = 0; fixBubble();
    // Mobile Kassen-Leiste auf /cart (Dawn-Abschnitt, wird nach Änderungen nicht neu gerendert)
    const sv = document.querySelector('.cart-sticky-checkout__value');
    // data-sm-gesamt mitziehen: assets/sm-warenkorb-gesamt.js hält das Feld auf diesem Wert, wenn Zepto eine eigene Summe hineinschreibt
    // Versand wie in sm-cart-summary: Satz des Landes (data-smc-satz), außer gratis ab Schwelle, mit Newsletter-Code oder als Brief unter 3,80 €
    if (sv && S) {
      const satz = +sv.getAttribute('data-smc-satz') || 0, versand = S.count && !view(S).shipFree && S.total >= 380 ? satz : 0;
      const t = money(S.cart.total_price + versand); if (sv.hasAttribute('data-sm-gesamt')) sv.setAttribute('data-sm-gesamt', t); sv.textContent = t;
    }
    if (S) { paintBar(S); paintStrip(S); }
    document.querySelectorAll('[data-smr-panel]').forEach((p) => { p.dataset.smrOn = 's'; paintPanel(p); });
    paintNotes();
  }

  // Freischalt-Moment: Hinweis und Pixel-Konfetti, nur wenn eine Stufe in dieser Sitzung neu erreicht wird
  function celebrate(st) {
    const v = view(st), prev = SS.get('smrLvl');
    SS.set('smrLvl', String(v.level));
    if (prev === null || v.level <= +prev) return;
    for (let i = +prev; i < v.level; i++) push('sm_reward_reached', { sm_reward: T[i].id, sm_cart_value: st.total / 100 });
    const t = T[v.level - 1];
    const d = document.createElement('div');
    d.className = 'smr-toast'; d.setAttribute('role', 'status');
    d.innerHTML = '<img src="' + t.img + '" alt=""><span><b>' + t.toast + '</b><small>' + t.hint + '</small></span>';
    document.body.appendChild(d);
    requestAnimationFrame(() => requestAnimationFrame(() => d.classList.add('in')));
    setTimeout(() => { d.classList.remove('in'); setTimeout(() => d.remove(), 400); }, 3800);
    if (RM) return;
    const drawer = document.querySelector('cart-drawer.active');
    const o = (drawer && drawer.querySelector('.smr-card')) || document.querySelector('.cart__items .smr-card') || document.querySelector('[data-smr-bar]');
    const r = o ? o.getBoundingClientRect() : { left: innerWidth / 2 - 120, width: 240, top: 90, height: 0 };
    const box = document.createElement('div');
    box.className = 'smr-confetti'; box.setAttribute('aria-hidden', 'true');
    const cols = ['#0044cc', '#6f9bff', '#f5ae2e', '#ff6b1f', '#eef0f2', '#1c7f47'];
    for (let i = 0; i < 44; i++) {
      const s = document.createElement('i'), z = [4, 6, 8][i % 3];
      s.style.cssText = 'left:' + (r.left + r.width * Math.random()) + 'px;top:' + (r.top + Math.min(r.height, 120) * 0.5) + 'px;width:' + z + 'px;height:' + z + 'px;background:' + cols[i % cols.length];
      box.appendChild(s);
      const dx = (Math.random() * 2 - 1) * 130, up = -(40 + Math.random() * 100), down = 180 + Math.random() * 240;
      s.animate([{ transform: 'translate(0,0)', opacity: 1 }, { transform: 'translate(' + dx * 0.5 + 'px,' + up + 'px)', opacity: 1, offset: 0.3 }, { transform: 'translate(' + dx + 'px,' + down + 'px) rotate(' + 90 * Math.ceil(Math.random() * 4) + 'deg)', opacity: 0 }],
        { duration: 1200 + Math.random() * 700, easing: 'cubic-bezier(.2,.6,.4,1)', fill: 'forwards' });
    }
    document.body.appendChild(box);
    setTimeout(() => box.remove(), 2200);
  }

  // Marker-Produkte (0 €) an den Warenkorb anpassen
  async function getCart() {
    const r = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!r.ok) throw new Error('cart ' + r.status);
    return r.json();
  }
  async function ensure(cart, st) {
    const adds = [], updates = {};
    T.forEach((t) => {
      const want = st.count > 0 && st.total >= t.cents && !(t.ersetzt && st.total >= T[t.ersetzt].cents), lines = cart.items.filter((i) => i.variant_id === t.marker);
      if (want && !lines.length) adds.push({ id: t.marker, quantity: 1 });
      lines.forEach((l, k) => { const q = want && k === 0 ? 1 : 0; if (l.quantity !== q) updates[l.key] = q; });
    });
    // Marker früherer Stufen (Mystery Gift bis 30.10.2026) aus noch offenen Warenkörben nehmen
    cart.items.forEach((l) => { if ((C.alt || []).indexOf(l.variant_id) > -1 && l.quantity) updates[l.key] = 0; });
    // Geschenktüte aus dem Schalter (schwarz, Menge 1) in der passenden Größe halten, ohne passenden Artikel entfernen
    let bagAdd = null;
    const bags = cart.items.filter((i) => isBag(i) && i.quantity === 1);
    if (bags.length && st.items.some((i) => !isBag(i))) {
      const need = bagNeed(st.items), wantBag = need === 2 ? BAG.g : need === 1 ? BAG.k : 0, keep = bags.find((l) => l.variant_id === wantBag);
      bags.forEach((l) => { if (l !== keep) updates[l.key] = 0; });
      if (wantBag && !keep) bagAdd = { id: wantBag, quantity: 1 };
    }
    // Attribut des früheren Mystery Gift leeren, falls es noch im Warenkorb steht
    const attrs = cart.attributes || {}, attrChange = !!(C.giftAttr && attrs[C.giftAttr]);
    let changed = false;
    if (Object.keys(updates).length || attrChange) {
      const body = { updates };
      if (attrChange) body.attributes = { [C.giftAttr]: '' };
      changed = (await fetch(ROOT + 'cart/update.js', { method: 'POST', headers: JSONH, body: JSON.stringify(body) })).ok || changed;
    }
    if (adds.length) changed = (await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: adds }) })).ok || changed;
    // Eigene Anfrage, damit eine ausverkaufte Tüte die Marker nicht mitreißt
    if (bagAdd) changed = (await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify({ items: [bagAdd] }) })).ok || changed;
    return changed;
  }
  // Nach Marker-Änderungen neu rendern, sonst stimmen Dawns Zeilennummern im Drawer nicht mehr
  function refreshViews() {
    const di = document.querySelector('cart-drawer-items');
    if (di && typeof di.onCartUpdate === 'function') di.onCartUpdate();
    const ci = document.querySelector('cart-items');
    if (ci && typeof ci.onCartUpdate === 'function') ci.onCartUpdate();
  }

  let running = null, queued = false;
  async function syncOnce() {
    let cart = await getCart(), st = derive(cart), changed = false;
    // Zweiter Durchgang, falls der Tausch der Geschenktüte den Betrag über oder unter eine Stufe schiebt
    for (let n = 0; n < 2 && await ensure(cart, st); n++) { changed = true; cart = await getCart(); st = derive(cart); }
    if (changed) { S = st; refreshViews(); }
    S = st;
    renderAll();
    celebrate(st);
  }
  function sync() {
    if (running) { queued = true; return running; }
    running = (async () => {
      try { do { queued = false; await syncOnce(); } while (queued); } catch (e) { /* Leiste bleibt beim letzten Stand */ } finally { running = null; }
    })();
    return running;
  }
  let t0 = 0;
  const soon = () => { clearTimeout(t0); t0 = setTimeout(sync, 120); };

  // Kasse erst nach dem Abgleich, damit die Marker sicher in der Bestellung landen
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!running || !f || !/^(CartDrawer-Form|cart)$/.test(f.id) || f.dataset.smrWait) return;
    e.preventDefault();
    f.dataset.smrWait = '1';
    const sub = e.submitter;
    Promise.race([running, new Promise((r) => setTimeout(r, 2500))]).then(() => { try { f.requestSubmit(sub || undefined); } catch (x) { f.submit(); } });
  }, true);

  // Passt dazu: hinzufügen, im Drawer direkt neu rendern
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-smr-add]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;
    b.disabled = true; b.classList.add('is-busy');
    const v = S ? view(S) : null, drawer = document.querySelector('cart-drawer'), inDrawer = !!(drawer && drawer.contains(b));
    try {
      const body = { items: [{ id: +b.dataset.smrAdd, quantity: 1 }] };
      if (inDrawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = location.pathname; }
      const r = await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify(body) });
      const j = await r.json();
      if (!r.ok || j.status) throw new Error(j.description || r.status);
      push('sm_gapfill_add', { sm_item: b.dataset.smrKey, sm_gap: v ? v.gap / 100 : null, sm_next_reward: v && v.next ? v.next.id : null });
      if (inDrawer && typeof drawer.renderContents === 'function' && j.sections) drawer.renderContents(j);
      else { location.reload(); return; }
      soon();
    } catch (err) {
      b.disabled = false; b.classList.remove('is-busy'); b.textContent = 'Nicht verfügbar';
    }
  });

  // Änderungen unter den Artikeln (Geschenktüte, Nachricht) nicht an Dawn weitergeben: Dawn hält jede Änderung im Warenkorb für eine Mengenänderung
  document.addEventListener('change', async (e) => {
    if (!e.target.closest || !e.target.closest('.smc-extras')) return;
    e.stopPropagation();
    const c = e.target.closest('[data-smc-gift]');
    if (!c) return;
    const lab = c.closest('.smc-gift'), drawer = document.querySelector('cart-drawer'), on = c.checked;
    if (lab) lab.classList.add('is-busy');
    const sections = { sections: 'cart-drawer,cart-icon-bubble', sections_url: location.pathname };
    try {
      const r = on
        ? await fetch(ROOT + 'cart/add.js', { method: 'POST', headers: JSONH, body: JSON.stringify(Object.assign({ items: [{ id: +c.dataset.smcGift, quantity: 1 }] }, sections)) })
        : await fetch(ROOT + 'cart/change.js', { method: 'POST', headers: JSONH, body: JSON.stringify(Object.assign({ id: c.dataset.smcKey, quantity: 0 }, sections)) });
      const j = await r.json();
      if (!r.ok || j.status) throw new Error(j.description || r.status);
      push('sm_gift_wrap', { sm_on: on, sm_size: c.dataset.smcSize });
      if (drawer && drawer.contains(c) && typeof drawer.renderContents === 'function' && j.sections) drawer.renderContents(j); else { location.reload(); return; }
      soon();
    } catch (x) { c.checked = !on; if (lab) lab.classList.remove('is-busy'); }
  }, true);

  // Empfehlungen im Drawer: Shopify-Empfehlungen zum ersten Artikel, als Karten mit Link (personalisierte Produkte brauchen die Produktseite)
  const xsCache = {};
  const imgW = (u, w) => (u ? (u.indexOf('//') === 0 ? 'https:' + u : u) + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : '');
  async function paintXS(box) {
    const pid = box.dataset.smcXs;
    if (!pid) return;
    if (!xsCache[pid]) {
      try { const r = await fetch(ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=related'); xsCache[pid] = ((await r.json()).products || []); } catch (e) { xsCache[pid] = []; }
    }
    const inCart = new Set((S ? S.items : []).map((i) => i.product_id));
    // Keine Hilfsprodukte des Personalisierers (Gravur-Aufpreise), keine Versand- oder Sonderanfertigungs-Posten
    const skip = /^(PPLR_HIDDEN_PRODUCT|Sonderanfertigung|Versand|Gravur|Befestigungsset)$/i;
    const cards = xsCache[pid].filter((p) => p.available && !inCart.has(p.id) && p.price >= 500 && p.featured_image && !skip.test(p.type || '') && !/gravur auf der|einseitige gravur|beidseitige gravur/i.test(p.title)).slice(0, 6);
    if (!cards.length) { box.hidden = true; return; }
    box.querySelector('.smc-xs__row').innerHTML = cards.map((p) => '<a class="smc-xs__card" href="' + esc(p.url) + '" data-smc-xs-card="' + p.id + '"><img src="' + esc(imgW(p.featured_image, 300)) + '" alt="" loading="lazy" width="136" height="136"><div><b>' + esc(p.title) + '</b><span>' + (p.price_varies ? 'ab ' : '') + money(p.price) + '</span><em>Ansehen</em></div></a>').join('');
    box.hidden = false;
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('[data-smc-xs-card]');
    if (a) push('sm_xsell_click', { sm_product_id: +a.dataset.smcXsCard });
  });

  // Desktop-Zeitstrahl und der Knopf in den Handy-Details öffnen den Drawer
  document.addEventListener('click', (e) => {
    const bar = e.target.closest('[data-smr-strip], [data-smr-mgo]');
    const drawer = document.querySelector('cart-drawer');
    if (!bar || !drawer || typeof drawer.open !== 'function' || /\/cart\/?$/.test(location.pathname)) return;
    e.preventDefault();
    const mi = bar.closest('[data-smr-minfo]');
    if (mi) { mi.hidden = true; const tg = document.querySelector('[data-smr-mtoggle]'); if (tg) tg.setAttribute('aria-expanded', 'false'); }
    drawer.open(bar);
  });

  // Neu gerenderte Panels (Dawn ersetzt Drawer-Inhalt und Warenkorb-Zeilen) sofort füllen
  const mo = new MutationObserver(mountAll);
  const watch = () => document.querySelectorAll('cart-drawer, cart-items, #main-cart-footer, .cart__footer').forEach((n) => {
    if (n.dataset.smrWatch) return;
    n.dataset.smrWatch = '1';
    mo.observe(n, { childList: true, subtree: true });
  });
  const drawerEl = document.querySelector('cart-drawer');
  if (drawerEl) new MutationObserver(() => {
    if (!drawerEl.classList.contains('active') || !S || !S.count) return;
    once('panel_view', () => push('sm_reward_panel_view', { sm_level: view(S).level, sm_cart_value: S.total / 100 }));
    drawerEl.querySelectorAll('[data-smr-key]').forEach((b) => once('gv_' + b.dataset.smrKey, () => push('sm_gapfill_view', { sm_item: b.dataset.smrKey, sm_gap: view(S).gap / 100 })));
  }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });

  window.SMR = { sync, state: () => S, view: () => (S ? view(S) : null) };

  // Start: sofort aus Liquid-Werten zeichnen, dann mit /cart.js abgleichen
  if (mbar) paintBar({ total: +mbar.dataset.total || 0, count: +mbar.dataset.count || 0, items: [], shipCode: false });
  if (strip) paintStrip({ total: +strip.dataset.total || 0, count: +strip.dataset.count || 0, items: [], shipCode: false });
  watch(); mountAll();
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, soon);
  document.addEventListener('sm:cart-changed', soon);
  addEventListener('pageshow', (e) => { if (e.persisted) soon(); });
  sync();
})();
